import React from 'react'
import { InputContainer } from '../../../../../../common/components/form/form.module'
import { InputLabelContainer } from '../../../../../../common/components/form/label/containers/input-label.container'

export default function SettlementsBasicInfoComponent({
  handleInnerFormChange,
  selectedSettlement,
  onClose,
  handleFormSubmit
}: any) {

  return (
    <>
      <div className="flex justify-center items-center w-[600px]">
        <div className="w-full max-w-lg p-2 bg-white shadow-md rounded-md">
          <h1 className="text-xl font-bold mb-4 text-center">{selectedSettlement?.Settlement?.Id ? "Edit Settlement" : "Add New Settlement"}</h1>
          <div className="flex flex-col gap-4">
          <InputContainer
              label="Orer Id"
              name="OrderId"
              onValueChange={(event: any) => {
                handleInnerFormChange({
                  value: event.target.value,
                  path:'OrderId',
                })
              }}
              type="text"
              value={selectedSettlement?.OrderId}
            />
            <InputContainer
              label="Collector"
              name="CollectorAppId"
              onValueChange={(event: any) => {
                handleInnerFormChange({
                  value: event.target.value,
                  path:'CollectorAppId',
                })
              }}
              type="text"
              value={selectedSettlement?.CollectorAppId}
            />
            <InputContainer
              label="Receiver"
              name="ReceiverAppId"
              onValueChange={(event: any) => {
                handleInnerFormChange({
                  value: event.target.value,
                  path: 'ReceiverAppId',
                })
              }}
              type="text"
              value={selectedSettlement?.ReceiverAppId}
            />
          
            <InputContainer

              label="Type"
              name="SettlementTypeId"
              onValueChange={(event: any) => {
                handleInnerFormChange({
                  value: event.target.value,
                  path: 'SettlementTypeId',

                })
              }}
              type="text"
              value={selectedSettlement?.SettlementTypeId}
            />
            <InputContainer

              label="Status"
              name="SettlementStatusId"
              onValueChange={(event: any) => {
                handleInnerFormChange({
                  value: event.target.value,
                  path: 'SettlementStatusId',

                })
              }}
              type="text"
              value={selectedSettlement?.SettlementStatusId}
            />
          </div>
          <div className="flex justify-end mt-6">
            <button
              onClick={onClose}
              type="button"
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
            >
              Close
            </button>
            <button
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
              onClick={handleFormSubmit}
              type="submit"
            >
              Save
            </button>
          </div>
        </div>
      </div>

    </>
  )
}